export const AUTHORITIES = {
  EGRADANIN: 'ROLE_EGRADANIN',
  NEPRIJAVLJENI: 'ROLE_NEPRIJAVLJENI',
  VODITELJ: 'ROLE_PROCELNIK',
};

export const MANDATES = {
  SUBMISSION: 'SUBMISSION',
  ADDITION: 'ADDITION',
  VIEW: 'VIEW',
};

export const messages = {
  DATA_ERROR_ALERT: 'Internal Error',
  MANDATORY_FIELD: 'Obavezan podatak',
  DELETION_SUCCESSFUL: 'Zahtjev je uspješno izbrisan.',
  ONLY_DIGITS: 'Dozvoljeno je unijeti samo brojeve',
  OIB_MIN_MAX_LENGTH: 'Oib mora imati 11 znakova',
  MB_MAX_LENGTH: 'MB mora imati do 11 znakova',
  DATA_SAVED: 'Podaci su uspješno spremljeni.',
  DOCUMENT_SIZE_LIMIT: 'Dokument koji se učitava ne smije biti veći od 20 MB.',
  DOCUMENT_PDF_FORMAT: 'Dokument koji se učitava mora biti u pdf formatu.',
  FETCHING_DOCUMENT_ERROR: 'Došlo je do pogreške prilikom preuzimanja dokumenta. Pokušajte ponovno.',
  FILE_TOO_LARGE: 'Datoteka ne smije biti veća od 100 MB!',
  FILE_NOT_PDF: 'Datoteka mora biti u pdf formatu!',
  DATA_DELETED: 'Podaci su uspješno obrisani.',
  DATA_COPIED: 'Podaci su uspješno kopirani.',
  OIB_FETCHED: 'Podaci su uspješno dohvaćeni.',
  ATTACHMENT_DELETED: 'Prilog je uspješno obrisan.',
  ACTION_SUCCESSFUL: 'Akcija je uspješno izvršena.',
  MANDATORY_FIELDS_NOT_FILLED: 'Potrebno je popuniti obvezne podatke na crveno označenim karticama!',
  CASE_DELEGATED: 'Predmet je uspješno delegiran.',
  DOCUMENT_SIGNED: 'Dokument je uspješno potpisan.',
  DOCUMENT_NOT_SIGNED: 'Došlo je do pogreške prilikom potpisa dokumenta! Pokušajte ponovno.',
  MB_MIN_MAX_LENGTH: 'MB mora imati 11 znakova',
};

export const TABLE_QUERY_KEYS = {
  CASE_ATTACHMENTS_TABLE: 'case-attachments-table',
  PREVIOUS_DOCUMENTS_TABLE: 'previous-documents-table',
  APPLICANTS_TABLE: 'applicants-table',
  BUILDINGS_TABLE: 'buildings-table',
  CONSTRUCTIONS_TABLE: 'constructions-table',
  INTERVENTIONS_TABLE: 'interventions-table',
  RPJ_LOCATIONS_TABLE: 'rpj-locations-table',
  DKP_LOCATIONS_TABLE: 'dkp-locations-table',
  PROJECT_DOCUMENTS_TABLE: 'project-documents-table',
  MAIN_PROJECT_DOCUMENTS_TABLE: 'main-project-documents-table',
  CASE_REVISION_TABLE: 'main-project-revision-table',
  CASE_CONSTRUCTION_LEGALITY_DOCUMENTS_TABLE: 'case-construction-legality-documents-table',
  SITE_CONSTRUCTORS_TABLE: 'site-constructors-table',
  SITE_SUPERVISORS_TABLE: 'site-supervisors-table',
  LOCATION_PERMIT_COMPLIANCE_TABLE: 'location-permit-compliance-table',
  CASE_PUBLIC_AUTHORITY_TABLE: 'case-public-authority-table',
  FINAL_REPORTS_TABLE: 'final-reports-table',
  WRITTEN_STATEMENTS_TABLE: 'written-statements-table',
  PARTIES_TABLE: 'parties-table',
  ADDED_PEOPLE_TABLE: 'added-people-table',
  PLOT_BEING_CERATED_TABLE: 'plot-being-created-table',
  SPECIAL_BUILDING_PARTS_TABLE: 'special-building-parts-table',
};

export const CASE_TAB_ENUM = {
  CASE_REGISTRY: 'K-03',
  APPLICANTS: 'K-14',
  CONSTRUCTION_BUILDING_PROCEDURE: 'K-16',
  PROJECT_DOCUMENTS: 'K-21',
  MAIN_PROJECT_DOCUMENTS: 'K-22',
  APPLICANTS_V2: 'K-37',
  CONSTRUCTION_BUILDING_PROCEDURE_V2: 'K-38',
  PROJECT_DOCUMENTS_V2: 'K-39',
  MAIN_PROJECT_DOCUMENTS_V2: 'K-40',
  CASE_REGISTRY_V2: 'K-41',
};

export const ERRORS = {
  GENERIC_ERROR: 'Došlo je do pogreške. Molimo kontaktirajte administratora.',
  ERROR_ACT_GENERATION: 'Došlo je do pogreške prilikom izrade akta! Pokušajte kasnije.',
  ERROR_CASE_WITH_WEB_ID_NOT_FOUND: 'Nije pronađen zahtjev koji odgovara unesenim podacima!',
  ERROR_CASE_WITH_WEB_ID_IN_WRONG_STATUS: 'Za uneseni zahtjev nije dozvoljeno nastaviti unos podataka!',
  ERROR_OIB_NOT_FOUND: 'Ne postoje podaci za uneseni OIB!',
  ERROR_INVALID_OIB: 'Uneseni OIB je neispravan!',
  ERROR_30_DAYS_PASSED_FROM_CREATING_CASE: 'Prošao je rok za predaju zahtjeva! Potrebno je pokrenuti novi zahtjev.',
  ZIS_SERVICE_UNAVAILABLE_ERROR: 'Nije moguće dohvatiti podatke iz sustava ZIS! Pokušajte kasnije.',
  LOCATION_SERVICE_NOT_WORKING_ERROR: 'Nije moguće dohvatiti podatke o lokaciji zahvata! Pokušajte kasnije.',
  ZONING_PLAN_SERVICE_NOT_WORKING_ERROR: 'Nije moguće dohvatiti podatke o važećim prostornim planovima! Pokušajte kasnije.',
};

export const CASE_STATUS_ID_ENUM = {
  STATUS_ZAPRIMANJE_ZAHTJEVA: 3,
  STATUS_DODJELA_REFERENTA: 4,
  STATUS_OVJERA: 6,
  STATUS_ARHIVIRANJE: 9,
  STATUS_ARHIVA: 10,
};

export const FILE_TYPES = {
  EXCEL: 'excel',
  PDF: 'pdf',
};

export const APP_DATE_FORMAT = 'DD.MM.YYYY.';
export const APP_TIME_FORMAT = 'HH:mm:ss';
export const APP_TIMESTAMP_FORMAT = 'DD.MM.YYYY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';

// documents
export const FILE_SIZE_LIMIT_IN_MEGABYTES = 20;
export const BYTES_IN_A_MEGABYTE = 1000000;

export const EDOZVOLA_WEB_ID_REGEX = /^[P|J|A]\d{8}-\d+-[V|Z]\d{2,6}$/;
export const PUBLIC_WEB_INPUT_STATUS = 'Unos na javnom portalu'

export const CROATIA_COUNTRY_ID = 83;
export const CROATIA_COUNTRY_VALUE = 'Hrvatska';
export const PARCEL_REGEX = /^[0-9/*]*$/;

export const MAX_FILE_SIZE = 1024 * 1000 * 100;

export const ISPU_LOCATOR_TAB_CLOSE_FLAG = 'ISPU_LOCATOR_TAB_CLOSED';

export const GLOBAL_NOTIFICATION_DISPLAY_ID = 2;
export const GLOBAL_NOTIFICATION_FETCH_INTERVAL_S = 30;
export const MAX_FILE_NAME_LENGTH = 60;

export const RECAPTCHA_SITE_KEY = '6LfsyRYsAAAAAIPwD6NtCBKVbhTnZjnEeeMq2l87';
